import _isEmpty from 'lodash/isEmpty';
import { STORAGE_KEY } from '../constants/generic';

/**
 * The in-flight booking draft that a full-page round trip destroys - the
 * worldpay payment redirect and the Keycloak login share it. Restoration is
 * already wired: SearchBookingsList re-opens the recap popup for the stored
 * VEHICLE_ID once the search results are in, and BookingRecapPopup walks to the
 * confirm step and re-applies the stored custom-field values from RECAP_DATA.
 * (The search query itself needs no storage here: the round trip returns to the
 * /book URL that still carries it - the payment flow stores it separately only
 * because its return lands on /redirect.)
 */
export function saveBookingDraft({ selectedVehicle, customFieldsValues }) {
  const { id: vehicleId } = selectedVehicle?.vehicle || {};

  if (vehicleId) window.localStorage.setItem(STORAGE_KEY.VEHICLE_ID, vehicleId);

  // RECAP_DATA doubles as the "walk to the confirm step" marker, so it is
  // written even when there are no custom-field values to carry.
  const recapData = _isEmpty(customFieldsValues) ? true : customFieldsValues;

  window.localStorage.setItem(STORAGE_KEY.RECAP_DATA, JSON.stringify(recapData));
}

// For the round trip that never started (e.g. the login redirect failed to
// build): stale keys would otherwise re-open the recap on the next search.
export function clearBookingDraft() {
  window.localStorage.removeItem(STORAGE_KEY.VEHICLE_ID);
  window.localStorage.removeItem(STORAGE_KEY.RECAP_DATA);
}
